import React, { useRef } from 'react'
import { Helmet } from "react-helmet";
import Hero from '../../components/GetStarted/Hero';
import Benefits from '../../components/GetStarted/Benefits';
import Audience from '../../components/GetStarted/Audience';
import Guide from '../../components/GetStarted/Guide';
import Testimonials from '../../components/Home/Testimonials';


const GetStarted = () => {
    const guideRef = useRef(null);

    const scrollToGuide = () => {
      guideRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

  return (
    <>
     <Helmet>
  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Basic Meta */}
  <title>Get Started | Aptech Lekki Centre - Launch Your Tech Career</title>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta
    name="description"
    content="Ready to start your journey in tech? Discover how Aptech Lekki Centre can help you build a future-proof career with expert-led IT training, industry-recognized certifications, and career guidance. Get started with us today!"
  />

  <meta
    name="keywords"
    content="Get started in tech Nigeria, Aptech Lekki enroll, Start coding career Lekki, Begin IT training Lagos, Learn programming Nigeria, Career in software engineering, IT skills development Lekki, Start learning web development, Tech education Nigeria, Join Aptech Lekki"
  />

  <meta name="author" content="Aptech Lekki Centre" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://aptechlekki.com/get-started" />

  {/* Open Graph Meta for Social Media */}
  <meta property="og:title" content="Get Started | Aptech Lekki Centre" />
  <meta property="og:description" content="Take the first step towards a successful tech career with Aptech Lekki Centre. Enroll in our IT training programs and join a global network of tech professionals." />
  <meta property="og:url" content="https://aptechlekki.com/get-started" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Get Started | Aptech Lekki Centre" />
  <meta name="twitter:description" content="Start your journey into tech today with Aptech Lekki's career-driven IT training programs." />
  <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
</Helmet>

    <Hero onGetStartedClick={scrollToGuide} />
    <Benefits />
    <Audience />
    <Testimonials />
    <Guide ref={guideRef} />
    </>
  )
}

export default GetStarted